module.exports = __webpack_public_path__ + "img/type(5).c9981d4b.png";